import { useState } from 'react'
import {
  TypographyElement,
  Paper,
  Icon,
  Icons
} from 'UI'
import Text from './text.json'
import style from './style'
import { createUseStyles } from 'react-jss'
import { ProfileTypes } from 'constants/'
import SmartTableOfContent from 'components/Course/SmartTableOfContent'
const useStyle = createUseStyles(style)

export default ({
  learningMode,
  play,
  hideTitle,
  hideCollapse,
  selectVideoToWatch,
  showPopUpAction,
  scrollToPricing,
  setPlay,
  ProfileType,
  noBorder,
  height,
  showAndHideController,
  controllerState
}) => {
  const [expand, setExpand] = useState(true)
  const { paperClass, headerClass, controllerIcon } = useStyle({ learningMode, play, height, controllerState })
  const videoClickHandler = (video) => {
    if (video.IsLocked) {
      if (!ProfileType || ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.FreeSubscriber) scrollToPricing()
    } else {
      showPopUpAction(true)
      selectVideoToWatch(video)
      setPlay && setPlay(true)
    }
  }

  return (
    <>
      <Paper className={paperClass}>
        <div className={headerClass}>
          {
            learningMode || play || hideTitle
              ? null
              : (
                <TypographyElement
                  variant='heading2'
                  Component='h2'
                >
                  {Text.title}
                </TypographyElement>
                )
          }
          {
            play || hideCollapse
              ? null
              : (

                <TypographyElement
                  variant='body2'
                  cursor='pointer'
                  handleClick={() => setExpand(!expand)}
                >
                  {expand ? Text.shrink : Text.expand}
                </TypographyElement>
                )
          }
          {
            showAndHideController
              ? (
                <Icon
                  iconName={controllerState ? Icons.arrowRight : Icons.navigationMenu}
                  onHandleIconClick={() => showAndHideController(!controllerState)}
                  style={controllerIcon}
                />
                )
              : null
          }
        </div>
        {
          !showAndHideController || controllerState
            ? (
              <div>
                <SmartTableOfContent
                  noBorder={noBorder}
                  standAloneChapters={learningMode}
                  learningMode={learningMode || play}
                  expandAll={expand}
                  videoClickHandler={videoClickHandler}
                  setPlay={setPlay}
                  handleClick
                  height={height}
                />
              </div>
              )
            : null
        }
      </Paper>
    </>
  )
}
